import React from 'react';
import { RoadMapTab } from './components/roadmap/RoadMapTab';
interface AppProps {
  /** Row spacing for the field lists. */
  density?: 'compact' | 'comfortable';
  /** Show the Salesforce object + API name beneath each field label. */
  showApiNames?: boolean;
}
export function App({
  density = 'compact',
  showApiNames = false
}: AppProps) {
  return <RoadMapTab density={density} showApiNames={showApiNames} data-id="element-0" data-mp="3fb9n3lijrwsd" />;
}